import React, { useContext } from "react"
import { Modal } from "react-bootstrap";
import { Autocomplete, Button, InputLabel, TextField, MenuItem, Select } from "@mui/material";
import language from "../../../nls/language.json";
import Context from "../../../context/Context";
import '../Combinations.css';

export default function EditPieceModal({
  ShowModalEdit,
  setShowModalEdit,
  handleAddPieces,
  selectedPieces,
  grupoPecas,
  pecasOptions,
  putPieces,
  checkSaveBtn
}) {
  const {
    selectedCountry,
  } = useContext(Context);

  return (
    <Modal size="lg" show={ShowModalEdit} onHide={() => setShowModalEdit(false)}>
      <Modal.Header closeButton>
        <Modal.Title>
          {language[selectedCountry.name].Cadastro.combinacoes.pecas.modal.editarPeca.title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="px-4 py-3">
        <div className="d-flex flex-row gap-3">
          <div className="d-flex flex-column w-50">
            <InputLabel sx={{ fontSize: '0.95rem', fontWeight: 600, mb: 1 }}>
              {language[selectedCountry.name].Cadastro.combinacoes.pecas.modal.editarPeca.labels.peca}
            </InputLabel>
            <Autocomplete
              options={pecasOptions}
              getOptionLabel={(opt) => `${opt.descricao} (${opt.valor})`}
              filterOptions={(opts, { inputValue }) =>
                opts.filter(o =>
                  o.descricao.toLowerCase().includes(inputValue.toLowerCase()) ||
                  o.valor.toLowerCase().includes(inputValue.toLowerCase())
                )
              }
              value={pecasOptions.find(o => o.valor === selectedPieces.pecaGrupo_CodPeca) ?? null}
              onChange={(_, opt) => handleAddPieces({ name: "pecaGrupo_CodPeca", value: opt?.valor ?? "" }, "EDIT_PECA")}
              renderInput={(params) => (
                <TextField {...params} required fullWidth placeholder="Selecione a Peça" />
              )}
            />
          </div>

          <div className="d-flex flex-column w-50">
            <InputLabel sx={{ fontSize: '0.95rem', fontWeight: 600, mb: 1 }}>
              {language[selectedCountry.name].Cadastro.combinacoes.pecas.modal.editarPeca.labels.grupo}
            </InputLabel>
            <Select
              value={selectedPieces.pecaGrupo_Nome}
              onChange={({ target }) => {
                handleAddPieces({ name: "pecaGrupo_Nome", value: target.value }, "EDIT_PECA")
              }}
            >
              {grupoPecas.map((itemProd, i) => (
                <MenuItem
                  key={`grupPiece-${itemProd.prodGrupo_GrupoNome}-${i}`}
                  value={itemProd.prodGrupo_GrupoNome}
                >
                  {itemProd.prodGrupo_GrupoNome}
                </MenuItem>
              ))}
            </Select>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="text"
          sx={{ marginRight: 2 }}
          onClick={() => setShowModalEdit(false)}
        >
          {language[selectedCountry.name].Cadastro.combinacoes.pecas.modal.editarPeca.btnCancelar}
        </Button>
        <Button
          variant="contained"
          onClick={() => putPieces(selectedPieces)}
          disabled={checkSaveBtn(selectedPieces)}
        >
          {language[selectedCountry.name].Cadastro.combinacoes.pecas.modal.editarPeca.btnSalvar}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
